export default __webpack_public_path__ + "static/media/logoBlack.cce64be0.svg";